/**
 * Tiny ring buffer of recent console.error output, attached to review notes
 * so support sees what was failing when the note was filed. Installed once at
 * app boot (src/main.tsx); costs nothing and answers "what broke?".
 */

const MAX_ENTRIES = 10;
const MAX_LENGTH = 500;

const buffer: string[] = [];
let installed = false;

function toLine(args: unknown[]): string {
  return args
    .map((a) => {
      if (typeof a === 'string') return a;
      if (a instanceof Error) return `${a.name}: ${a.message}`;
      try {
        return JSON.stringify(a);
      } catch {
        return String(a);
      }
    })
    .join(' ')
    .slice(0, MAX_LENGTH);
}

export function installConsoleErrorBuffer(): void {
  if (installed) return;
  installed = true;
  const original = console.error.bind(console);
  console.error = (...args: unknown[]) => {
    try {
      buffer.push(`${new Date().toISOString()} ${toLine(args)}`);
      if (buffer.length > MAX_ENTRIES) buffer.shift();
    } catch {
      // never let diagnostics break the console
    }
    original(...args);
  };
}

/** Newest-last copy of the recent console errors. */
export function getRecentConsoleErrors(): string[] {
  return [...buffer];
}
